import { render } from "./GiftSubscriptionLimitSelectionForm.vue?vue&type=template&id=7b2e760e&ts=true"
import script from "./GiftSubscriptionLimitSelectionForm.vue?vue&type=script&lang=ts"
export * from "./GiftSubscriptionLimitSelectionForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__